import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (iso) => {
  try { return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }); }
  catch { return ""; }
};

const LatestInsights = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/articles?limit=3`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="insights-latest" className="section bg2" data-testid="latest-insights">
      <div className="w">
        <div className="eyebrow">Insights</div>
        <h2 className="h2">Latest <em className="gold">Insights</em></h2>
        <p style={{ color: "var(--g1)", maxWidth: 620, marginTop: "0.8rem", lineHeight: 1.7 }}>
          Practical analysis on early borrower-risk identification, foreclosure prevention, and servicing governance — updated continually.
        </p>
        <div className="insights-grid" style={{ padding: "2rem 0 1rem", maxWidth: "none" }}>
          {items.map((a) => (
            <button
              key={a.id}
              className="insight-card"
              onClick={() => navigate(`/insights/${a.slug}`)}
              data-testid={`latest-card-${a.slug}`}
            >
              {a.tags?.length > 0 && (
                <div className="insight-card-tags">
                  {a.tags.slice(0, 3).map((t) => <span className="insight-tag" key={t}>{t}</span>)}
                </div>
              )}
              <h3>{a.title}</h3>
              <p>{a.excerpt || a.meta_description}</p>
              <div className="insight-card-meta">
                <span>{fmt(a.published_at || a.created_at)}</span>
                <span className="insight-card-read">Read →</span>
              </div>
            </button>
          ))}
        </div>
        <button className="btn-hero" onClick={() => navigate("/insights")} data-testid="view-all-insights" style={{ marginTop: "1.2rem" }}>
          View all insights →
        </button>
      </div>
    </section>
  );
};

export default LatestInsights;
